import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { GLOBAL } from '../global';

@Injectable()
export class RegimenFiscalService {
  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  getRegimenFiscalLista(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(`${this.basePath}regimen-fiscal/obtener-rf`, options);
  }

  getRegimenFiscalPorRFC(rfc): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('rfc', rfc)
    };
    return this.http.get(`${this.basePath}regimen-fiscal/obtener-por-rfc`, options);
  }

  postRegimenFiscal(noRegimen, descRegimen, rfcSociedad, claveSociedad): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
       .set('no_regimen', noRegimen)
       .set('desRegimenFiscal', descRegimen)
       .set('rfcSociedad', rfcSociedad)
       .set('clave_sociedad', claveSociedad)

    };
    return this.http.post(`${this.basePath}regimen-fiscal/insertar-regimen`, '', options);
  }

  updateRegimenFiscal(data): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.put(`${this.basePath}regimen-fiscal/actualizar-regimen`, data, options);
  }

  deleteRegimenFiscal(idRegimen): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('id', idRegimen)
    };
    return this.http.delete(`${this.basePath}regimen-fiscal/borrar-regimen`, options);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/regimen-fiscal/regimen-fiscal.service.ts